import actions from "./actions";

const initState = {
  idToken: null,
  userId: null,
  account: {},
  userSurveyStatus: null,
  accessInformation: null,
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return {
        idToken: action.token,
        userId: action.userId,
        userSurveyStatus: action.userSurveyStatus,
        accessInformation: action.accessInformation,
      };

    case actions.LOGOUT:
      return initState;

    case actions.REGISTER_SUCCESS:
      return {
        ...state,
        account: action.user,
      };

    case actions.USER_SURVEY_STATUS_SUCCESS:
      return {
        ...state,
        userSurveyStatus: action.userSurveyStatus,
      };

    default:
      return state;
  }
}
